import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const CompanyForm = ({ isOpen, onClose, company, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    address: '',
    phone: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (company) {
      setFormData({
        name: company.label || company.name || '',
        contact: company.contact || '',
        address: company.address || '',
        phone: company.phone || '',
        email: company.email || ''
      });
    } else {
      setFormData({
        name: '',
        contact: '',
        address: '',
        phone: '',
        email: ''
      });
    }
  }, [company, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onSave(formData);
      onClose();
    } catch (error) {
      console.error('Error saving company:', error);
      alert('Error saving company. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={company ? 'Edit Company' : 'Add Company'} size="sm">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Company Name *</label>
            <input
              type="text"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="e.g. Transport SRL"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Contact Person</label>
            <input
              type="text"
              name="contact"
              className="form-input"
              value={formData.contact}
              onChange={handleChange}
              placeholder="e.g. John Doe"
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Address</label>
          <textarea
            name="address"
            className="form-textarea"
            value={formData.address}
            onChange={handleChange}
            placeholder="Company address"
            rows="3"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input
              type="tel"
              name="phone"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
              placeholder="e.g. +40 123 456 789"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              placeholder="e.g. contact@company.com"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Saving...' : (company ? 'Update Company' : 'Add Company')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CompanyForm;